// @ts-strict-ignore
import Link from 'next/link'
import { Dispatch, MouseEvent, SetStateAction } from 'react'

import arrowIcon from 'assets/svg/newArrow.svg'

import { IActiveMenu } from '@/widgets/burger-menu/ui/burger-menu/burger-menu'

import { Nullable } from '@/shared/types/common'
import { TSection } from '@/shared/types/deprecated-types'
import { Text } from '@/shared/ui'
import { AnimationDirection } from '@/shared/ui/Animation/Animation'
import { Icon } from '@/shared/ui/icon'

import styles from './NavItem.module.scss'

export type NavItemProps = {
	setActiveMenu: Dispatch<SetStateAction<IActiveMenu>>
	closeSideBar: () => void
	onMouseOver?: (string) => void
	onMouseLeave?: () => void
	isActive?: boolean
	targetBlank?: boolean
	icon?: string
	note?: string
	prefetch?: boolean
} & TSection

export const NavItem = ({
	title,
	link,
	closeSideBar,
	targetBlank,
	items,
	setActiveMenu,
	id,
	note,
	prefetch = false
}: NavItemProps): JSX.Element => {
	const handleClick = (evt: MouseEvent<HTMLElement>): Nullable<void> => {
		evt.preventDefault()
		setActiveMenu({
			sectionId: id,
			direction: AnimationDirection.Forward
		})
	}

	const hasChildren = !!items?.length
	const rootClassName = [styles.navItem, `navItemRoot`]
	if (hasChildren) rootClassName.push(styles.navItem_disabled)

	return (
		<div className={rootClassName.join(' ')}>
			<Link
				href={link}
				prefetch={prefetch}
				className={`${styles.link} navItemLink`}
				title={`Перейти на страницу «${title}»`}
				aria-label={`Категория «${title}»`}
				target={targetBlank ? `_blank` : `_self`}
				rel={targetBlank ? `noreferrer` : undefined}>
				<>
					<Text as="span">{title}</Text>{' '}
					{note && (
						<>
							<br />
							<Text as="span">{note}</Text>
						</>
					)}
				</>
			</Link>
			{hasChildren && (
				<button
					className={styles.button}
					onClick={hasChildren ? handleClick : closeSideBar}
					type="button"
					aria-label={`Показать вложенные категории раздела «${title}»`}
					title={`Показать вложенные категории раздела «${title}»`}>
					<Icon width={24} height={24} icon={arrowIcon} />
				</button>
			)}
		</div>
	)
}
